import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import VideoPlayer from './VideoPlayer';
import PdfViewer from './PdfViewer';
import SlideViewer from './SlideViewer';
import EmbedPlayer from './EmbedPlayer';
import ImageViewer from './ImageViewer';

const Notice = styled.div`
  background: #FEF3C7;
  color: #92400E;
  padding: 12px 14px;
  border-radius: 6px;
  font-size: 13px;
`;

/**
 * Dispatches to the right player based on ContentType.
 *
 * PPTX renders slide-by-slide via SlideViewer once the background job
 * has produced per-slide PNGs (slideUrls populated). Until then we show
 * a "still preparing" notice.
 */
export default function ContentPlayer({
  contentItem,
  assignmentId,
  disableFastForward = false,
  onCompleted,
  onProgress,
}) {
  const { t } = useTranslation();

  switch (contentItem.contentType) {
    case 'video':
      return (
        <VideoPlayer
          contentItem={contentItem}
          assignmentId={assignmentId}
          disableFastForward={disableFastForward}
          onCompleted={onCompleted}
          onProgress={onProgress}
        />
      );
    case 'pdf':
      return (
        <PdfViewer
          contentItem={contentItem}
          assignmentId={assignmentId}
          onCompleted={onCompleted}
          onProgress={onProgress}
        />
      );
    case 'pptx':
      if (!contentItem.slideUrls || contentItem.slideUrls.length === 0) {
        return <Notice>{t('training.pptxNotReady')}</Notice>;
      }
      return (
        <SlideViewer
          contentItem={contentItem}
          assignmentId={assignmentId}
          onCompleted={onCompleted}
          onProgress={onProgress}
        />
      );
    case 'youtube':
    case 'vimeo':
      return (
        <EmbedPlayer
          contentItem={contentItem}
          assignmentId={assignmentId}
          onCompleted={onCompleted}
          onProgress={onProgress}
        />
      );
    case 'image':
      return (
        <ImageViewer
          contentItem={contentItem}
          assignmentId={assignmentId}
          onCompleted={onCompleted}
          onProgress={onProgress}
        />
      );
    default:
      return <Notice>{t('training.unsupportedContentType')}</Notice>;
  }
}
